import React from "react";
import { ProgramContainer } from "../../entities/formTemplateDataType";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    dialogVisible: boolean;
    callback;
}

interface State {
    subject: string;
    body: string;
    subjectFRA: string;
    bodyFRA: string;
}

export class DialogForInboxContents extends React.Component<Props, State> {
    fillInboxContentEditor;
    constructor(props: Props) {
        super(props);
        this.state = {
            subject: props.programContainer.InboxSubject || '',
            body: props.programContainer.InboxBody || '',
            subjectFRA: props.programContainer.InboxSubjectFRA || '',
            bodyFRA: props.programContainer.InboxBodyFRA || '',
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (!prevProps.dialogVisible && this.props.dialogVisible) {
            this.setState({
                subject: this.props.programContainer.InboxSubject || '',
                body: this.props.programContainer.InboxBody || '',
                subjectFRA: this.props.programContainer.InboxSubjectFRA || '',
                bodyFRA: this.props.programContainer.InboxBodyFRA || '',
            });
        }
    }

    renderFooter = () => {
        return (
            <div>
                <Button
                    label="OK"
                    icon="pi pi-check"
                    onClick={() => {
                        this.props.programContainer.InboxSubject = this.state.subject;
                        this.props.programContainer.InboxBody = this.state.body ? this.state.body : ' ';
                        this.props.programContainer.InboxSubjectFRA = this.state.subjectFRA;
                        this.props.programContainer.InboxBodyFRA = this.state.bodyFRA ? this.state.bodyFRA : ' ';
                        this.props.callback(false);
                    }}
                />
                <Button
                    label="Cancel"
                    onClick={() => {
                        this.props.callback(false);
                    }}
                />
            </div>
        );
    };

    generateContentString = () => {
        return (
            <div style={{ width: "100%", paddingTop: "5px" }}>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '30%' }}>
                        <label htmlFor={"tbl_InboxSubject_" + this.props.programContainer.id}>Subject</label>
                    </div>
                    <div style={{ width: '60%' }}>                   
                        <InputText
                            style={{ width: '100%' }}
                            id={"tbl_InboxSubject_" + this.props.programContainer.id}
                            //value={this.state.subject}
                            value={(this.props.isEng ? this.state.subject : this.state.subjectFRA) || ''}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                     this.setState({ subject: e.target.value });
                                }
                                else{
                                     this.setState({ subjectFRA: e.target.value });
                                }
                             this.props.callback();
                            }}
                        />                       
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '30%' }}>
                        <label htmlFor={"tbl_InboxBody_" + this.props.programContainer.id}>Content</label>
                    </div>
                    <div style={{ width: '60%' }}>
                         {/* @ts-ignore */}
                         {this.fillInboxContentEditor && (                                
                            <Editor
                            style={{ height: 'auto', width: '100%' }}
                            id={"tbl_InboxBody_" + this.props.programContainer.id}
                            //value={this.state.body}
                            value={(this.props.isEng ? this.state.body : this.state.bodyFRA) || ''}
                            onTextChange={(e) => {
                                 if (this.props.isEng) {
                                    this.setState({ body: e.htmlValue });
                                 }
                                 else{
                                    this.setState({ bodyFRA: e.htmlValue });
                                 }
                                 this.props.callback();
                            }}
                        /> 
                         )}                                                    
                         {!this.fillInboxContentEditor && (
                         <InputTextarea
                            className="ontario-input"
                            id={"tbl_InboxBody_" + this.props.programContainer.id}
                            //value={this.state.body}
                            value={(this.props.isEng ? this.state.body : this.state.bodyFRA) || ''}
                            onChange={(e) => {
                                 if (this.props.isEng) {
                                    this.setState({ body: e.target.value });
                                 }
                                 else{
                                    this.setState({ bodyFRA:  e.target.value });
                                 }
                                 this.props.callback();
                            }}
                          /> 
                         )}
                         <button onClick={() => {
                                    this.fillInboxContentEditor = !this.fillInboxContentEditor;
                                    this.props.callback();
                            }}>
                                {this.fillInboxContentEditor == true ? "Raw" : "HTML"}
                        </button>
                     </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <Dialog
                header={this.props.isEng ? "Inbox contents" : "Contenu de la boite de reception"}
                footer={this.renderFooter()}
                visible={this.props.dialogVisible}
                style={{ width: '50vw' }}
                onHide={() => this.props.callback(false)}
            >
                {this.generateContentString()}
            </Dialog>
        );
    }
}
